/* istanbul ignore file */
import { OfficeDropdown } from 'domain/shared/employee';

const VacancyOfficeDropdown = (props: any) => {
  return <OfficeDropdown {...props} />;
};

export default VacancyOfficeDropdown;
